"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_common_1 = require("fmko-ts-common");
/**
 * @deprecated The class definition is too broad, use more narrow classes
 */
class Tag extends fmko_ts_common_1.Widget {
    constructor(tag, text) {
        super();
        this.element = document.createElement(tag);
        this.setText(text);
    }
    setText(text) {
        if (text) {
            this.element.innerHTML = fmko_ts_common_1.HTMLUtils.sanitizeHTML(text);
        }
    }
    getText() {
        return this.element.innerHTML;
    }
}
exports.default = Tag;
//# sourceMappingURL=Tag.js.map